const BASE_PATH = "app/ls-search/";

export const SET_LAST_SEARCH = `${BASE_PATH}set-last-search`;
